import {
	VBtn,
	VCard,
	VCardActions,
	VCardText,
	VCardTitle,
	VDialog,
	VIcon,
	VSpacer
} from "vuetify/lib";
import { getPrefixedScopedSlots } from "kinnect-helpers";

export default {
	name: "ReportFilters",

	props: {
		filters: {
			required: true,
			type: Array,
			validator: filters =>
				filters.every( filter =>
					typeof filter === "object"
						&& filter.hasOwnProperty( "key" )
						&& typeof filter.key === "string"
						&& filter.hasOwnProperty( "value" )
				)
		}
	},

	data: () => ( {
		open: false,
		modelValues: {}
	} ),

	watch: {
		open( val ) {
			if ( val ) {
				this.setInitialValues();
			}
		}
	},

	methods: {
		save() {
			this.open = false;

			this.$emit( "save", this.modelValues );
		},

		cancel() {
			this.open = false;
		},

		setInitialValues() {
			this.filters.forEach( filter => {
				this.$set( this.modelValues, filter.key, filter.value );
			} );
		},

		genScopedFilters() {
			const prefix = "filter.";
			const scopedSlots = getPrefixedScopedSlots( prefix, this.$scopedSlots );

			return Object.keys( scopedSlots ).map( scopedSlot => {
				const props = {
					modelValues: this.modelValues
				};

				Object.defineProperty( props, "model", {
					get: () => this.modelValues[scopedSlot],
					set: val => this.modelValues[scopedSlot] = val
				} );

				return this.$scopedSlots[`${prefix}${scopedSlot}`]( props );
			} );
		}
	},

	render() {
		return <VDialog
			maxWidth="320"
			vModel={this.open}
			scopedSlots={{
				activator: ( { on } ) =>
					<VBtn class="d-print-none" dark on={on} text>
						<VIcon left>filter_list</VIcon> Filters
					</VBtn>
			}}
		>
			<VCard>
				<VCardTitle class="text-h6">Report Filters</VCardTitle>

				<VCardText>
					{this.genScopedFilters()}
				</VCardText>

				<VCardActions>
					<VSpacer></VSpacer>

					<VBtn
						onClick={this.cancel}
						text
					>Cancel</VBtn>

					<VBtn
						color="link"
						onClick={this.save}
						text
					>Apply</VBtn>
				</VCardActions>
			</VCard>
		</VDialog>;
	}
};
